module.exports = __webpack_public_path__ + "static/106422465-1583256951146rts34kgh-ae6c0426f21515f585f81637a7496a21.jpg";